<template>
  <div class="questions" :style="listZoom" :class="`questionsZoom`">
    <div
      v-for="(question, index) in questionsData"
      :key="index"
      :ref="`questionScroll-${question.id}`"
      class="item"
      v-show="!onlyWrong ? true : question.state === 2"
    >
      <div class="exam-question" style="display: flex">
        <div style="flex: 1 1 auto">
          <span>
            {{ index + 1 }}.
            {{ question.topic }}
          </span>
        </div>
        <div
          class="tool"
          style="
            display: block;
            flex: 0 1;
            padding-left: 10px;
            text-align: right;
            min-width: 150px;
          "
        >
          <span
            style="
              color: #e6a23c;
              text-decoration-line: underline;
              text-underline-offset: 5px;
            "
            >得分:<i>{{ question.examScore }}</i></span
          >
          <span style="color: #3a8ee6; padding-left: 10px; white-space: nowrap;"
            >满分:<i>{{ question.score }}</i></span
          >
        </div>
      </div>
      <div class="answers">
        <ul class="questions-list" style="padding: 0 20px">
          <!-- <li style="background: #fdd3d3">
            <div style="margin-left: 8px" class="context">
              <el-radio label="1" style="width: 100%; color: #ff0000">
                0. 测试标题测试标题测试标题测试标题测试标题
              </el-radio>
            </div>
          </li>
          <li style="background: #d8eafd">
            <div style="margin-left: 8px" class="context">
              <el-radio label="1" style="width: 100%; color: #409eff">
                0. 测试标题测试标题测试标题测试标题测试标题
              </el-radio>
            </div>
          </li> -->
          <li
            v-for="(option, optIndex) in question.options"
            :key="optIndex"
            :style="{
              background: bindAnsweredOrWrong(
                optIndex + 1,
                question.selecteds,
                question.answer
              ),
              margin: '1px 0 0',
            }"
          >
            <div style="margin-left: 8px" class="context">
              <template v-if="question.questionType === 2">
                <el-checkbox
                  disabled
                  v-model="question.selecteds"
                  :label="(optIndex + 1) | numberToLetter"
                  style="width: 100%"
                  >{{ (optIndex + 1) | numberToLetter }}.
                  {{ option.value }}</el-checkbox
                ></template
              >
              <template v-else>
                <el-radio
                  disabled
                  v-model="question.selecteds[0]"
                  :label="(optIndex + 1) | numberToLetter"
                  style="width: 100%"
                >
                  {{ (optIndex + 1) | numberToLetter }}. {{ option.value }}
                </el-radio>
              </template>
            </div>
          </li>
        </ul>
        <div style="padding: 0px 20px">
          <p style="padding: 5px 0">
            <span>正确答案：{{ question.answer.join("、") }}</span>
          </p>
          <p style="padding: 5px 0">
            <span>答题解析：{{ question.analysis }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { numberToLetter } from "@/utils";
export default {
  name: "Questions",
  props: {
    questionsData: {
      type: Array,
      default() {
        return [];
      },
    },
    zoom: {
      type: Number,
      default: 0,
    },
    onlyWrong: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    bindAnsweredOrWrong() {
      return (optIndex, selecteds, answer) => {
        const optValue = numberToLetter(optIndex);
        // console.log(optValue, selecteds, answer);
        if (selecteds.includes(optValue)) {
          if (answer.includes(optValue)) {
            return "#d8eafd";
          } else {
            return "#fdd3d3";
          }
        }
      };
    },
    bindAnsweredOrWrongText() {
      return (optIndex, selecteds, answer) => {
        const optValue = numberToLetter(optIndex);
        if (selecteds.includes(optValue)) {
          if (answer.includes(optValue)) {
            return "#409eff";
          } else {
            return "#ff0000";
          }
        }
      };
    },
    listZoom() {
      return {
        "--fontSize": `${16 * (this.zoom / 100) + 16}px`,
        "--width": `${14 * (this.zoom / 100) + 14}px`,
        "--height": `${14 * (this.zoom / 100) + 14}px`,
        "--radioWidth": `${4 * (this.zoom / 100) + 4}px`,
        "--radioHeight": `${4 * (this.zoom / 100) + 4}px`,
        "--checkboxWidth": `${3 * (this.zoom / 100) + 3}px`,
        "--checkboxHeight": `${7 * (this.zoom / 100) + 7}px`,
        "--checkboxLeft": `${4 * (this.zoom / 100) + 4}px`,
        "--checkboxBorder": `${2 * (this.zoom / 100) + 2}px`,
        "--inputHeight": `${36 * (this.zoom / 100) + 36}px`,
        "--inputFontSize": `${14 * (this.zoom / 100) + 14}px`,
      };
    },
  },
  methods: {
    scrollToAnchor(anchor) {
      this.$nextTick(() => {
        const element = this.$refs[`questionScroll-${anchor}`][0];
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
          window.scrollBy(0, element.getBoundingClientRect().top - 68);
        }
      });
    },
    handTestQuestionEvent(data) {
      const question = this.questionsData.find((i) => i.id === data.questionId);
      question.handTestQuestion = data.value;
    },
    doneEdit(e, question) {
      const value = e.target.value.trim();

      if (value > question.score) {
        e.target.value = question.score;
        // 教师评分
        question.handScore = question.score;
      } else {
        // 教师评分
        question.handScore = value;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.questionsZoom {
  ::v-deep {
    span {
      font-size: var(--fontSize) !important;
    }
    .el-radio__inner {
      width: var(--width);
      height: var(--height);
    }
    .el-radio__inner::after {
      width: var(--radioWidth);
      height: var(--radioHeight);
    }
    .el-checkbox__inner {
      width: var(--width);
      height: var(--height);
    }
    .el-checkbox__inner::after {
      width: var(--checkboxWidth);
      height: var(--checkboxHeight);
      left: var(--checkboxLeft);
      border: none;
      border-bottom: var(--checkboxBorder) solid #fff;
      border-right: var(--checkboxBorder) solid #fff;
    }

    .el-input__inner {
      height: var(--inputHeight) !important;
    }
    .el-input--medium {
      font-size: var(--inputFontSize);
    }

    .el-radio__input.is-disabled + span.el-radio__label {
      color: #606266;
    }
    .el-checkbox__input.is-disabled + span.el-checkbox__label {
      color: #606266;
    }
  }
}

.questions {
  .item {
    padding: 10px 0;
    position: relative;
  }
  .item .exam-question {
    font-size: 16px;
    line-height: 36px;
    padding: 5px 0;

    position: relative;
  }
  .item .answers {
    overflow: auto;
  }

  .questions-list {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .questions-list li {
    position: relative;
  }

  // .questions-list li:hover {
  //     background-color: #ededed;
  // }

  .questions-list li .context {
    display: flex;
    min-height: 32px;
    align-items: center;
  }

  .questions-list li .context ::v-deep .el-radio__label {
    font-size: 16px;
  }
  .questions-list li .context .el-radio {
    margin-right: 0px;
  }
  .questions-list li .context label {
    font-weight: normal;

    word-break: break-all;
    padding: 10px 5px;
    display: block;
    line-height: 1;
    font-size: 16px;
    transition: color 0.4s;
  }
}

.questions .item:not(:last-child) {
  border-bottom: 1px solid #dedede;
}
</style>